export default __webpack_public_path__ + "static/media/help_bg.92ee2e48.jpg";